import { ISelectListener } from './types'
import CommonService from '@services/common.service'

import { useDeviceType } from '@hooks/useDeviceType'

import imgEmty from '@img/empty.svg'
import { IconClearClose, IconListeners, IconQuestion, IconSearch } from '@img/icons'

import { Empty, Flex, ToolTip, Pagination, Loader, Input, Drawer, Divider, Button, Table, Container } from '@ui/index'
import css from './ui.module.scss'


/** Выбор слушателя */
export const SelectListener = ({
    isOpen, handlerButtonOk, handlerButtonCancel,
    isLoading, totalCount, pageSize, listenersList, 
    txtSearch, txtSearchOnChange, currentPageNumber,
    handleOpenCardListener,
}: ISelectListener) => {
    const deviceType = useDeviceType()
    
    return <Drawer isOpen={isOpen} placement='right'>
        <Flex className='drawer_container'>
            <Flex flexDirection='row' alignItems='center' justifyContent='space-between' className='drawer_container-header'>
                <header>
                    <Flex gap='4px' flexDirection='row' alignItems='center'>
                        <IconListeners color='#fff' width='20px' height='20px' />
                        <h4>Выбор слушателя</h4>
                    </Flex>
                </header>

                <Button variant='icon' size='md' onClick={handlerButtonCancel}>
                    <IconClearClose />
                </Button>
            </Flex>

            <Flex gap='4px' className='drawer_container-body'>
                <Loader isOpen={isLoading} backdrop title="Загрузка..." />

                <Flex gap='6px' className='drawer_container-content' overflowY='hidden' padding='2px 0px 0px 0px'>
                    <Flex gap='4px' flexDirection='row' justifyContent='space-between'>
                        <Input size="md" placeholder="Поиск..." paddingLeft='6px' paddingRight='6px' width='100%'
                            value={txtSearch.value} onChange={(e) => txtSearchOnChange(e.target.value)}
                            prefix={<IconSearch width='16px' height='16px' color="var(--foreground_accent_default)" />}
                            suffix={<>
                                {txtSearch.value && <Button id='tooltipBtnClear' size="xs" variant="icon" onClick={() => txtSearchOnChange('')}><IconClearClose width='18px' height='18px' /></Button>}
                                
                                <ToolTip placement='bottomRight' title={<>Поиск по:<br/>🗸 Фамилии<br/>🗸 Имени<br/>🗸 Отчеству<br/>🗸 Телефону<br/>🗸 Email<br/>🗸 СНИЛС<br/>🗸 Паспорту<br/>🗸 Адресу<br/>🗸 Диплому</>}>
                                    <IconQuestion width={deviceType === 'mobile' ? '16px' : '20px'} height={deviceType === 'mobile' ? '16px' : '20px'} color="var(--foreground_accent_default)" />
                                </ToolTip>
                            </>}
                        />

                        <Button size="md" variant="primary" padding='0 10px' onClick={() => handleOpenCardListener(true, 'new')}>СОЗДАТЬ</Button>
                    </Flex>

                    <Divider />

                    <Table.Content>
                        {!listenersList.length 
                            ? <Empty image={imgEmty} title='Контрагенты отсутствуют' /> 
                            : listenersList.map((item) => (
                                <Table.Row key={item.listenerID} onClick={() => handlerButtonOk && handlerButtonOk(item.listenerID, CommonService.declensionFullName(item.lastName, item.firstName, item.secondName, 'кому/чему'), item.registration)}>
                                    <div style={{ textWrap: 'nowrap', overflow: 'hidden' }}>
                                        <p>{item.lastName} {item.firstName} {item.secondName}</p>
                                        <Flex gap='5px' flexDirection='row'><p style={{ opacity: '.7' }}>{item.phoneNumber}</p> / <p style={{opacity: '.7', color: `${item.snils.length > 14 && 'red'}`}}>{item.snils}</p></Flex>
                                    </div>
                                </Table.Row>
                            ))
                        }
                    </Table.Content>

                    <Container className={css['footer']}>
                        <Pagination totalCount={totalCount} pageSize={pageSize} currentPage={currentPageNumber.value} onChange={(e) => currentPageNumber.setValue(e)} />
                    </Container>
                </Flex>
            </Flex>
        </Flex>
    </Drawer>
}